import React, { useState, forwardRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Slide,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
} from '@mui/material';
import Iconify from '../common/iconify.component';
import SnackbarInfo from '../common/snackbar-info.component';
import { viewVideoById } from '../../services/content.service';
import VideoUpload from './video-upload.component';
import ImageUpload from './image-upload.component';
import { CONTENT_ALIAS } from '../../config/const.config';
import SrtBulkUpload from './bulk-srt-upload.component';

const Transition = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const UploadAssets = ({
  title,
  dataId,
  dataTitle,
  onCancel,
  videoContentType,
  from,
}) => {
  const [loading, setLoading] = useState(true);
  const [videoData, setVideoData] = useState({
    videoUrl: '',
    thumbnail: '',
  });
  const [snackbarInfo, setSnackbarInfo] = useState({
    show: false,
    type: '',
    message: '',
  });
  const [renderImage, setRenderImage] = useState(false);

  const showUpdatedImage = (rerender) => {
    if (rerender) {
      setLoading(true);
    }
    setRenderImage(rerender);
  };

  const showToastMsg = (msgType, message) => {
    if (msgType === 'error') {
      setSnackbarInfo({
        show: true,
        type: 'error',
        message,
      });
    }

    if (msgType === 'success') {
      setSnackbarInfo({
        show: true,
        type: 'success',
        message,
      });
    }
  };

  useEffect(() => {
    viewVideoById(dataId)
      .then((res) => {
        setVideoData({
          ...videoData,
          videoUrl: res.data?.videoUrl || '',
          thumbnail: res.data?.thumbnail || '',
        });
        setLoading(false);
      })
      .catch(() => {
        setVideoData({
          ...videoData,
          videoUrl: '',
          thumbnail: '',
        });
        setLoading(false);
      });
  }, [renderImage]);

  return (
    <Dialog
      open
      onClose={() => onCancel()}
      aria-labelledby="add-dialog-title"
      aria-describedby="add-dialog-description"
      TransitionComponent={Transition}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle id="view-dialog-title">{`${CONTENT_ALIAS.VIDEO_PLURAL} - ${title}`}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onCancel}
        size="small"
        sx={{
          position: 'absolute',
          right: 10,
          top: 15,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Iconify icon="ic:outline-close" />
      </IconButton>

      <DialogContent dividers id="add-dialog-description">
        <form id="upload-assets-form">
          {videoContentType === 'videos' && (
            <Box
              component="section"
              sx={{
                p: 3,
                border: '2px solid lightgrey',
                borderRadius: '5px',
                width: '100%',
                marginTop: 3,
              }}
            >
              <ImageUpload
                title="Thumbnail"
                dataId={dataId}
                showToastMsg={showToastMsg}
                setSnackbarInfo={setSnackbarInfo}
                videoData={videoData}
                loading={loading}
                showUpdatedImage={showUpdatedImage}
                from={from}
              />
            </Box>
          )}
          <Box
            component="section"
            sx={{
              p: 3,
              border: '2px solid lightgrey',
              borderRadius: '5px',
              width: '100%',
              marginTop: 3,
            }}
          >
            <VideoUpload
              dataId={dataId}
              dataTitle={dataTitle}
              showToastMsg={showToastMsg}
              videoData={videoData}
              setSnackbarInfo={setSnackbarInfo}
              videoContentType={videoContentType}
            />
          </Box>

          <Box
            component="section"
            sx={{
              p: 3,
              border: '2px solid lightgrey',
              borderRadius: '5px',
              width: '100%',
              marginTop: 3,
            }}
          >
            <SrtBulkUpload
              dataId={dataId}
              dataTitle={dataTitle}
              showToastMsg={showToastMsg}
              onSuccess={() => {}}
              setSnackbarInfo={setSnackbarInfo}
              videoData={videoData}
              bulkUpload
            />
          </Box>
        </form>
      </DialogContent>

      {snackbarInfo.show && (
        <SnackbarInfo type={snackbarInfo.type} message={snackbarInfo.message} />
      )}
    </Dialog>
  );
};

UploadAssets.propTypes = {
  title: PropTypes.string.isRequired,
  dataId: PropTypes.number.isRequired,
  dataTitle: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  videoContentType: PropTypes.string.isRequired,
  from: PropTypes.string.isRequired,
};

export default UploadAssets;
